import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { HomeSelector } from '../reducers/HomeReducer';
import ReSign from '../../components/ReSign/ReSign';
import ReSignAction from '../actions/ReSignAction';
import { ReSignSelector } from '../reducers/ReSignReducer';

const mapStateToProps = state => ({
  error: HomeSelector.getError(state),
  info: ReSignSelector.customerInfo(state),
  response: ReSignSelector.reSignResponse(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    getCustomerInfo: ReSignAction.getCustomerInfo,
    reSign: ReSignAction.reSign
  }, dispatch);


const ReSignContainer = connect(mapStateToProps, mapDispatchToProps)(ReSign);

export default ReSignContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ReSignContainer.js
 **/